import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible/flexible'
// import './config/rem'
import './style/base.css'
import './config/rotate'
import VueLazyLoad from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'
// import Vueresource from "vue-resource"
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: './static/error.png',
  loading: './static/loading.png',
  attempt: 1,
  lazyComponent: true
}).use(VueClipboard)
import axios from 'axios'
Vue.prototype.axios = axios
// Vue.prototype.$http = Vueresource
axios.defaults.withCredentials = true;
// console.log(JSON.parse(localStorage.getItem('user')).id)
import qs from 'qs';

// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.baseURL = 'http://106.15.73.87:886/api/'
axios.defaults.baseURL = 'https://nmapi.huokongjian.net/api/'
// axios.create({
//   headers: 'token'
// });
axios.interceptors.request.use(function (config) {
  // consttoken=localStorage.getItem('token')
  // constuid=localStorage.getItem('uid')
  //判断请求的类型
  //如果是post请求就把默认参数拼到data里面
  //如果是get请求就拼到params里面
  // console.log(config)
  const uid = JSON.parse(localStorage.getItem('user')).id
  let tokens = localStorage.getItem("token");
  // console.log(uid)
  if (tokens) {
    let token = JSON.parse(localStorage.getItem('token')).id
    config.headers.token = token
    // config.headers.Authorization = `token ${token}`
    // config.headers.Authorization = token
  }

  if (config.method === 'post') {
    if (config.url == "uploadCertificate") {
    } else {

      let data = qs.parse(config.data)
      config.data = qs.stringify({
        // token:token,
        ...data,
        uid: uid,
      })
    }

  } else if (config.method === 'get') {
    // console.log(config)
    // if (config.url == 'alipay') {
    //   config.params = {
    //     // token:token,

    //     ...config.params
    //   }
    // } else {
    //   config.params = {
    //     // token:token,
    //     uid: uid,
    //     ...config.params
    //   }
    // }
    config.params = {
      // token:token,
      uid: uid,

      ...config.params
    }
  }
  return config;
}, function (error) {
  returnPromise.reject(error);
})
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.baseURL = 'http://mapi.huokongjian.net/'
// import VueAxios from 'vue-axios'

// Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
